export default {
  name: "email",
  in: "header",
  required: false,
  description:
    "An e-mail that serves as a user identifier for the system to return information - one of identifier must be filled",
  schema: {
    type: "string",
    example: "john@doe.com"
  }
};
